// 系统管理路由
export const systemRoutes = [
  {
    path: "/roleList",
    meta: {
      title: "角色管理",
    },
    component: () => import("@/pages/roleList"),
  },
  {
    path: "/userList",
    meta: {
      title: "用户管理",
    },
    component: () => import("@/pages/userList"),
  },
  {
    path: "/menuList",
    meta: {
      title: "菜单管理",
    },
    component: () => import("@/pages/menuList"),
  },
  {
    path: "/logList",
    meta: {
      title: "日志管理",
    },
    component: () => import("@/pages/logList"),
  },
  {
    path: "/colorList",
    meta: {
      title: "配色方案管理",
    },
    component: () => import("@/pages/colorList"),
  },
  {
    path: "/outerPath",
    meta: {
      title: "外部链接",
    },
    component: () => import("@/pages/outerPath"),
  },
  {
    path: "/departmentList",
    meta: {
      title: "部门管理",
    },
    component: () => import("@/pages/departmentList"),
  },
  {
    path: "/dataLink",
    meta: {
      title: "系统数据目录",
    },
    component: () => import("@/pages/dataLink"),
  },
  {
    path: "/messageCenter",
    meta: {
      title: "消息中心",
    },
    component: () => import("@/pages/message"),
  },
  {
    path: "/formSet",
    meta: {
      title: "表单设置",
    },
    component: () => import("@/pages/formSet"),
  },
];

// 流程管理相关
export const flowRoutes = [
  {
    path: "/flowList",
    meta: {
      title: "流程图flowable定义列表",
    },
    component: () => import("@/pages/flowable/defineList.vue"),
  },
  {
    path: "/taskCenter",
    name: "taskCenter",
    meta: {
      title: "流程任务中心",
    },
    component: () => import("@/pages/flowable/taskList.vue"),
  },
  {
    path: "/flowable",
    meta: {
      title: "流程图flowable版本",
    },
    component: () => import("@/pages/flowable"),
  },
];
